function inOutSine(n) {
  return 0.5 * (1 - Math.cos(Math.PI * n));
}

function animateTo(to, opts) {
  const { duration = 350 } = opts || {};
  const start = Date.now();
  const from = window.pageYOffset;
  const distance = to - from;
  if (Math.abs(distance) < 10) {
    window.scrollTo(0, to);
    return;
  }

  function animate() {
    const now = Date.now();
    const time = (now - start) / duration;
    if (time >= 1) {
      window.scrollTo(0, to);
      return;
    }

    const change = inOutSine(time) * distance;
    window.scrollTo(0, from + change);
    requestAnimationFrame(animate);
  }

  requestAnimationFrame(animate);
}

export default animateTo;
